var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Checkbox.styles.scss';
var Checkbox = function (_a) {
    var ariaLabel = _a.ariaLabel, disabled = _a.disabled, label = _a.label, name = _a.name, _b = _a.id, id = _b === void 0 ? window.crypto.randomUUID() : _b, onChange = _a.onChange, checked = _a.checked, readOnly = _a.readOnly, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c, value = _a.value;
    var getInputClassName = function () {
        var classList = ['hefesto-checkbox__item-check'];
        if (disabled) {
            classList.push('hefesto-checkbox__item-check--disabled');
        }
        else if (readOnly) {
            classList.push('hefesto-checkbox__item-check--read-only');
        }
        else {
            classList.push('hefesto-checkbox__item-check--primary');
        }
        return classList.join(' ');
    };
    var inputClassName = getInputClassName();
    return (_jsxs("div", __assign({ className: "hefesto-checkbox" }, { children: [_jsx("input", { "aria-label": ariaLabel, checked: checked, className: inputClassName, disabled: disabled, id: id, name: name, onChange: onChange, readOnly: readOnly, tabIndex: tabIndex, type: "checkbox", value: value }), _jsx("label", __assign({ className: "hefesto-checkbox__label", htmlFor: id }, { children: label }))] })));
};
export default Checkbox;
